// ProtectedRoute.jsx

import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/authContext';
import {
    createPostAuthDestination,
    persistPostAuthRedirect
} from '../auth/postAuthRedirect';

const ProtectedRoute = ({ children, allowedRoles }) => {
    const { user, loadingUser } = useAuth();
    const location = useLocation();

    if (loadingUser) {
        console.log("⏳ `ProtectedRoute.jsx` esperant a `loadingUser`...");
        return <div>Loading...</div>;
    }

    if (!user) {
        console.log("🔒 Usuari no autenticat. Guardant la ruta i redirigint a `/login`...");

        const postAuthDestination = createPostAuthDestination(location);

        if (postAuthDestination) {
            persistPostAuthRedirect(postAuthDestination);
        }

        return (
            <Navigate
                to="/login"
                replace
                state={{
                    from: {
                        pathname: location.pathname,
                        search: location.search,
                        hash: location.hash
                    }
                }}
            />
        );
    }

    if (allowedRoles && !allowedRoles.includes(user.role)) {
        return <Navigate to="/unauthorized" replace />;
    }

    return children;
};

export default ProtectedRoute;
